import { defineStore } from "pinia";

export type ConsentCategories = { analytics: boolean; marketing: boolean };

type State = {
  decided: boolean;
  categories: ConsentCategories;
  decidedAt?: string;
};

export const useConsentStore = defineStore("consent", {
  state: (): State => ({
    decided: false,
    categories: { analytics: false, marketing: false },
    decidedAt: undefined
  }),
  getters: {
    needsBanner: (s) => !s.decided,
    allowAnalytics: (s) => s.decided && s.categories.analytics,
    allowMarketing: (s) => s.decided && s.categories.marketing
  },
  actions: {
    acceptAll() {
      this.decided = true;
      this.categories = { analytics: true, marketing: true };
      this.decidedAt = new Date().toISOString();
    },
    allowEssentialOnly() {
      this.decided = true;
      this.categories = { analytics: false, marketing: false };
      this.decidedAt = new Date().toISOString();
    },
    saveChoices(cats: Partial<ConsentCategories>) {
      this.decided = true;
      this.categories = { ...this.categories, ...cats };
      this.decidedAt = new Date().toISOString();
    }
  },
  persist: { key: "cookie-consent-v1" }
});
